<template>
    <div class="wy-analytics-contact-reasons-detail" @click="handlePageClick" v-loading="loading">
      <div class="wy-page-title">
        <el-tooltip class="item" effect="dark" content="Go Back" placement="bottom">
          <el-button class="el-contack-reason-back" @click="handleBack"></el-button>
        </el-tooltip>
        <div class="wy-page-subtitle" ref="subTitle" :title="topicName" :contenteditable="isEditTopicName" @focus="handleFocus" @blur="handleBlur" @keydown="handleKeyDown" @click="handleClick">
          {{ topicName }}
        </div>
        <el-tooltip v-if="!isEditTopicName && currentItem" class="item" effect="dark" content="Edit Topic Name" placement="bottom">
          <el-button v-if="isRoleAllow([4201, 900011])" class="el-edit-pencil" @click="handleEditTopic"></el-button>
        </el-tooltip>
  
        <!-- <el-tooltip v-if="isEditTopicName" class="item" effect="dark" content="Confirm Change" placement="bottom">
          <el-button class="el-topic_confirm"></el-button>
        </el-tooltip> -->
        <!-- <span v-if="isEditTopicName" class="span-between">&nbsp;</span> -->
        <el-tooltip v-if="isEditTopicName" class="item" effect="dark" content="Cancel Change" placement="bottom">
          <el-button class="el-topic_cancel" @click="handleCloseEditTopic">Cancel</el-button>
        </el-tooltip>
        <el-tooltip v-if="isRoleAllow([4201, 900011]) && !isEditTopicName" class="item" effect="dark" content="Add to Blacklist" placement="bottom">
          <el-button class="black-list-btn" @click="handleBlackList"></el-button>
        </el-tooltip>
      </div>
      <div class="wy-page-tab" v-if="currentItem">
        <el-tabs ref="tabs" v-model="activeTab" @tab-click="handleTabClick">
          <el-tab-pane v-if="isTabEnable('metrics', 4200)" label="Metrics" name="metrics">
            <detailMetrics ref="metrics" :parent="module" :activeTab="activeTab" />
          </el-tab-pane>
          <!-- <el-tab-pane v-if="isTabEnable('metricAnalysis', 420002) && showMetricsTab" label="Metric Analysis" name="metricAnalysis" style="padding: 25px;">
            <detailTopicMetricAnalysis ref="metricAnalysis" :parent="module" :activeTab="activeTab" />
          </el-tab-pane> -->
          <!-- <el-tab-pane v-if="isTabEnable('messages', 420003)" label="Messages" name="messages" style="padding: 25px;">
            <detailTopicMessages ref="messages" :parent="module" :activeTab="activeTab" />
          </el-tab-pane> -->
          <el-tab-pane v-if="isTabEnable('conversations', 420004)" label="Transcripts" name="conversations">
            <detailTopicTranscripts ref="conversations" :parent="module" :activeTab="activeTab" />
          </el-tab-pane>
          <!-- <el-tab-pane v-if="isTabEnable('topicRelations', 420005)" label="Related Topics" name="topicRelations" style="padding: 25px;">
            <detailTopicRelations ref="topicRelations" :parent="module" :activeTab="activeTab" />
          </el-tab-pane> -->
          <el-tab-pane v-if="isTabEnable('entities', 420007)" label="Entities" name="entities">
            <detailTopicEntities ref="entities" :parent="module" :activeTab="activeTab" />
          </el-tab-pane>
          <el-tab-pane v-if="isTabEnable('groupedTopics', 420006)" label="Grouped Topics" name="groupedTopics" style="padding: 25px;">
            <detailTopicGroup ref="groupedTopics" :parent="module" :activeTab="activeTab" />
          </el-tab-pane>
          <!-- <el-tab-pane v-if="isTabEnable('intents', 420008)" label="Intents" name="intents" style="padding: 25px;">
            <detailTopicIntents ref="intents" :parent="module" :activeTab="activeTab" />
          </el-tab-pane> -->
        </el-tabs>
      </div>
      <div v-else class="no-result-found">
        <div class="no-data"></div>
        <div class="no-data-title">{{ $t('noResultFound.title') }}</div>
        <div class="no-data-content">
          <div class="content-text">
            {{ $t('noResultFound.message') }}
          </div>
        </div>
      </div>
  
      <!-- <wy-analytics-contact-reasons-black-list ref="blacklist" :controller="module" componentName="wy-analytics-contact-reasons-detail" /> -->
    </div>
  </template>
  
  <script>
  import Vue from 'vue';
  import { mapGetters, mapMutations } from 'vuex';
  import detailMetrics from '../../analytics/wy-analytics-contact-reasons-detail-metrics';
  // import detailTopicMessages from '../../analytics/wy-analytics-contact-reasons-detail-topic-messages';
  import detailTopicEntities from '../../analytics/wy-analytics-contact-reasons-detail-topic-entities';
  // import detailTopicRelations from '../../analytics/wy-analytics-contact-reasons-detail-topic-relations';
  import detailTopicTranscripts from '../../analytics/wy-analytics-contact-reasons-detail-topic-transcripts';
  import detailTopicGroup from '../../analytics/wy-analytics-contact-reasons-detail-topic-group';
  // import detailTopicIntents from '../../analytics/wy-analytics-contact-reasons-detail-topic-intents';
  // import detailTopicMetricAnalysis from '../../analytics/wy-analytics-contact-reasons-detail-metric-analysis.vue';
  // import WyAnalyticsContactReasonsBlackList from '../../analytics/wy-analytics-contact-reasons-black-list';
  
  export default Vue.extend({
    name: 'wy-interactions-phrase-categories-detail',
    props: ['parent', 'selectedItem'],
  
    components: {
      detailMetrics: detailMetrics,
      // detailTopicMessages: detailTopicMessages,
      detailTopicEntities: detailTopicEntities,
      // detailTopicRelations: detailTopicRelations,
      detailTopicTranscripts: detailTopicTranscripts,
      detailTopicGroup: detailTopicGroup,
      // detailTopicIntents: detailTopicIntents,
      // detailTopicMetricAnalysis: detailTopicMetricAnalysis,
      // 'wy-analytics-contact-reasons-black-list': WyAnalyticsContactReasonsBlackList,
    },
  
    data() {
      return {
        module: this,
        loading: false,
        activeTab: 'metrics',
        isEditTopicName: false,
        topicName: null,
        isClickEdit: false,
        currentItem: null,
        fetchData: true,
      };
    },
  
    computed: {
      ...mapGetters(['dataModel', 'isC1Auth', 'config', 'tableModel', 'isRoleAllow', 'isReadOnlyUser', 'authUser', 'transcriptInfoReference']),
  
      showMetricsTab() {
        if (!this.currentItem) return;
  
        const avgBes = this.currentItem.avgBes;
        const avgBas = this.currentItem.avgBas;
  
        const scoreIsHundred = avgBes == 100 && avgBas == 100;
        const scoreIsNegativeOne = avgBes == -1 && avgBas == -1;
  
        if (scoreIsHundred || scoreIsNegativeOne) {
          return false;
        }
  
        return true;
      },
    },
  
    watch: {
      topicName(value) {
        if (this.$refs.groupedTopics) {
          this.$refs.groupedTopics.groupName = value;
        }
      },
      isEditTopicName(value) {
        let dom = this.$refs.subTitle;
        if (dom && value) {
          dom.style.border = '1px solid #CAD2DA';
          dom.style['min-width'] = '200px';
        }
      },
    },
  
    methods: {
      ...mapMutations(['updateTranscriptInfoReference']),
  
      handleTranscriptPopover() {
        if (this.transcriptInfoReference) {
          this.transcriptInfoReference.visible = false;
          this.updateTranscriptInfoReference(null);
        }
      },
      
      isTabEnable(key, aclCode) {
        if (this.config.tabs == null || this.config.tabs[key] == null || this.config.tabs[key].enabled == null || this.config.tabs[key].enabled === true) {
          if(this.isC1Auth) {
            return this.isRoleAllow(aclCode);
          }
          else {
            if((key == "groupedTopics" || key == "messages")) {
              if(this.isRoleAllow(4201)) {
                if(this.config.tabs[key] && this.config.tabs[key].forInternalUsersOnly) {
                  return this.authUser.user.email.includes("@wysdom.ai");
                }
                else {
                  return true;
                }
              }
              else {
                return false;
              }
            }
            else {
              return true;
            }
          }
        }
        return false;
      },
  
      resetFetchDataStatus() {
        if (this.$refs.metrics) this.$refs.metrics.fetchData = true;
        if (this.$refs.metricAnalysis) this.$refs.metricAnalysis.fetchData = true;
        if (this.$refs.messages) this.$refs.messages.fetchData = true;
        if (this.$refs.entities) this.$refs.entities.fetchData = true;
        if (this.$refs.topicRelations) this.$refs.topicRelations.fetchData = true;
        if (this.$refs.conversations) this.$refs.conversations.fetchData = true;
        if (this.$refs.groupedTopics) this.$refs.groupedTopics.fetchData = true;
        if (this.$refs.intents) this.$refs.intents.fetchData = true;
      },
  
      refreshUI(item, options) {
        // NOTE: this prop item is the updated currentItem from parent, so must use this for conditions below
  
        if (!item) {
          // if date range has no data and user directed to go to available date,
          // reset the activeTab to metrics
          this.activeTab = 'metrics';
        }
  
        if (this.activeTab == 'metricAnalysis') {
          // if activeTab is metric analysis and avgBes && avgBas are both 100 or -1
          // cannot use showMetric from computed, since we need to get the avgBes and avgBas from the 
          // updated item prop!
          const avgBes = item.avgBes;
          const avgBas = item.avgBas;
  
          const scoreIsHundred = avgBes == 100 && avgBas == 100;
          const scoreIsNegativeOne = avgBes == -1 && avgBas == -1;
  
          if (scoreIsHundred || scoreIsNegativeOne) {
            this.activeTab = 'metrics';
          }
        }
  
        this.currentItem = item;
        this.resetFetchDataStatus();
        if (this.currentItem) {
          if (this.activeTab == 'metrics' && this.$refs.metrics) this.$refs.metrics.loadData();
          if (this.activeTab == 'metricAnalysis' && this.$refs.metricAnalysis) this.$refs.metricAnalysis.loadMetricAnalysis(item);
          if (this.activeTab == 'messages' && this.$refs.messages) this.$refs.messages.loadTopicMessages();
          if (this.activeTab == 'entities' && this.$refs.entities) this.$refs.entities.loadTopicEntities();
          if (this.activeTab == 'topicRelations' && this.$refs.topicRelations) this.$refs.topicRelations.loadTopicRelations();
          // if(this.activeTab == 'anomalies' && this.$refs.anomalies) this.$refs.anomalies.loadTopicAnomalies();
          if (this.activeTab == 'conversations' && this.$refs.conversations) this.$refs.conversations.loadTranscriptsData(true, options.filterName);
          if (this.activeTab == 'groupedTopics' && this.$refs.groupedTopics) this.$refs.groupedTopics.loadTopicGroup();
          if (this.activeTab == 'intents' && this.$refs.intents) this.$refs.intents.loadTopicIntents();
        } else {
          this.parent.loading = false;
        }
      },
  
      handleBack() {
        this.$parent.close();
      },
  
      handleTabClick(tab) {
        if(this.$root.preMsgObj) {
          this.$root.preMsgObj.visible = false;
          this.$root.preMsgObj.onClose()
        }
        if (this.$refs[tab.name]) {
          this.$refs[tab.name].startLoading();
        }
  
        // For metric analysis popover
        if (this.transcriptInfoReference) {
          this.transcriptInfoReference.visible = false;
          this.updateTranscriptInfoReference(null);
        }
      },
  
      stopLoadingByTab(tab) {
        if (this.activeTab == tab) {
          this.parent.loading = false;
        }
      },
  
      handleEditTopic() {
        this.isEditTopicName = true;
      },
      handleClick() {
        if (this.isEditTopicName) {
          let dom = this.$refs.subTitle;
          if (dom) {
            dom.focus();
            dom.style.border = '1px solid #106FBC';
          }
        }
      },
      handleKeyDown(event) {
        if (event.keyCode === 13) {
          event.target.blur();
        }
      },
  
      handleFocus() {
        // if(this.isEditTopicName) {
        //   event.preventDefault();
        //   event.target.style.border = '1px solid #106FBC';
        //   event.target.style["min-width"] = '200px';
        // }
      },
  
      handleBlur(event) {
        if (this.isEditTopicName) {
          event.preventDefault();
          let dom = this.$refs.subTitle;
          if (dom) dom.style.border = 'unset';
          event.target.style.border = 'unset';
  
          setTimeout(() => {
            let dom = document.querySelector('.wy-analytics-contact-reasons-detail .wy-page-subtitle');
            if (dom && dom.textContent) {
              let newTopicName = dom.textContent.trim();
              if (newTopicName && newTopicName != '' && this.currentItem.topicDisplayName && this.currentItem.topicDisplayName != newTopicName) {
                this.parent.updateTableData(this.currentItem, 'topicDisplayName', newTopicName, () => {
                  this.handleCloseEditTopic();
                });
              } else {
                this.handleCloseEditTopic();
              }
            } else {
              this.handleCloseEditTopic();
            }
          }, 200);
        }
      },
  
      handleCloseEditTopic() {
        this.topicName = this.currentItem.topicDisplayName.replace(/(<([^>]+)>)/gi, '');
        this.isEditTopicName = false;
  
        let dom = this.$refs.subTitle;
        if (dom) {
          dom.style['min-width'] = 'unset';
          dom.textContent = '';
          dom.style.border = 'unset';
          setTimeout(() => {
            dom.textContent = this.currentItem.topicDisplayName;
          }, 10);
        }
      },
  
      handleBlackList() {
        if (this.currentItem && this.currentItem.mergedTopics && this.currentItem.mergedTopics.length > 0) {
          let obj = {
            mergedTopics: this.currentItem.mergedTopics,
            topicDisplayName: this.topicName,
          };
          this.$refs.blacklist.handleBlackListOpen([obj]);
        }
      },
  
      handlePageClick() {
        if (this.activeTab == 'conversations' && this.$refs.conversations) {
          this.$refs.conversations.handleClickOnPage();
        }
  
        // if(this.activeTab == 'metricAnalysis' && this.$refs.metricAnalysis) {
        //   this.$refs.metricAnalysis.handleClickOnPage()
        // }
      },
    },
    mounted() {
      this.refreshUI(this.currentItem, {});
  
      // on resize window, we close the transcript popover
      window.addEventListener('resize', this.handleTranscriptPopover);
      // Outside of metric-analysis
      document.addEventListener('click', () => {
        this.handleTranscriptPopover();
      });
      // Inside metric-analysis
      document.querySelector('.wy-analytics-contact-reasons-detail').addEventListener('click', () => {
        this.handleTranscriptPopover();
      });
    },
  
    async created() {
      this.currentItem = this.selectedItem;
      this.topicName = this.currentItem.topicDisplayName.replace(/(<([^>]+)>)/gi, '');
      setTimeout(() => {
        let editorEle = this.$refs.subTitle;
        if (editorEle) {
          editorEle.addEventListener('paste', function(e) {
            e.preventDefault();
            const text = e.clipboardData ? (e.originalEvent || e).clipboardData.getData('text/plain') : window.clipboardData ? window.clipboardData.getData('Text') : '';
            if (document.queryCommandSupported('insertText')) {
              document.execCommand('insertText', false, text);
            } else {
              const range = document.getSelection().getRangeAt(0);
              range.deleteContents();
              const textNode = document.createTextNode(text);
              range.insertNode(textNode);
              range.selectNodeContents(textNode);
              range.collapse(false);
              const selection = window.getSelection();
              selection.removeAllRanges();
              selection.addRange(range);
            }
          });
        }
      }, 600);
    },
  
    beforeDestroy() {
      this.$root.$el.classList.remove('contactReasonDetail');
      this.parent.$refs.table.$el.style.display = 'block';
      if(this.$root.preMsgObj) {
        this.$root.preMsgObj.visible = false;
        this.$root.preMsgObj.onClose()
      }
    },
  });
  </script>
  
  <style lang="scss">
  .wy-analytics-contact-reasons-detail {
    // min-width: 1180px;
    // min-width: 1382px;
    padding-right: 0px;
    //margin-bottom: 20px;
    padding-top: 0px;
  
    .wy-page-title {
      height: 57px;
    }
  
    .el-table__body-wrapper {
      position: sticky !important;
      overflow-y: auto !important;
      height: calc(100vh - 440px);
    }
    .wy-page-subtitle {
      display: inline-block;
      margin: 0px 10px 0px 10px;
      font-size: 21px;
      background: transparent 0% 0% no-repeat padding-box;
      border: 3px solid transparent;
      border-radius: 5px;
      opacity: 1;
      padding: 5px 30px 5px 5px;
      position: relative;
      top: 6px;
      vertical-align: middle;
      outline: none;
      max-width: 450px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      border: 1px solid transparent !important;
    }
    [contenteditable='true'].wy-page-subtitle {
      white-space: nowrap;
      // width:450px;
      max-width: 650px;
      overflow: hidden;
      text-overflow: unset;
      border: 1px solid #cad2da !important;
    }
    [contenteditable='true'].wy-page-subtitle:focus {
      border: 1px solid #106fbc !important;
    }
    [contenteditable='true'].wy-page-subtitle br {
      display: none;
    }
    [contenteditable='true'].wy-page-subtitle * {
      display: inline;
      white-space: nowrap;
      text-overflow: unset;
    }
  
    .el-button {
      padding: 7px 15px 21px 10px;
      margin-left: 0px;
      margin-right: 11px;
    }
    .el-contack-reason-back {
      cursor: pointer;
      background-image: url('../../../assets/icons/icon_back.svg') !important;
      background-size: 44px;
      background-repeat: no-repeat;
      background-position-y: 0px;
      background-position-x: 0px;
      background-color: #f2f2f2;
      height: 44px;
      width: 44px;
      border: 0px;
    }
    .el-contack-reason-back:hover {
      background-color: #ebf4fd !important;
      // background-color: lightblue;
      background-position-y: 0px;
      background-position-x: 0px;
    }
  
    .el-edit-pencil {
      cursor: pointer;
      background-image: url('../../../assets/icons/icon_edit_pencil.svg') !important;
      background-size: 16px;
      background-repeat: no-repeat;
      background-position-y: 9px;
      background-position-x: 7px;
      background-color: transparent;
      height: 30px;
      width: 30px;
      border: 0px;
      // padding-bottom: 14px;
      position: relative;
      top: -9px;
      // margin-left: 20px;
    }
    .el-edit-pencil:hover {
      background-color: #ebf4fd !important;
    }
    .el-topic_confirm {
      cursor: pointer;
      background-image: url('../../../assets/icons/icon_topic_confirm.svg') !important;
      background-size: 24px;
      background-repeat: no-repeat;
      background-position-y: 10px;
      background-position-x: 9px;
      background-color: transparent;
      height: 36px;
      width: 40px;
      border: 0px;
      padding-bottom: 12px;
      margin-left: 38px;
    }
    .span-between {
      border-right: 2px solid #ecedef;
      position: absolute;
      top: 12px;
    }
    .el-topic_cancel {
      cursor: pointer;
      position: relative;
      font-weight: 500;
      background-color: unset;
      color: #106fbc;
      border: unset;
      border-right: 15px solid transparent !important;
      font-family: 'Helvetica Neue', sans-serif;
      transition: 0s;
      span {
        top: 5px;
        position: relative;
      }
      &:hover {
        background-color: unset;
      }
    }
  
    .wy-page-link {
      cursor: pointer;
      display: inline-block;
      border-bottom: 2px solid #fff;
    }
    .wy-page-link:hover {
      border-bottom: 2px solid #002852;
    }
  
    .black-list-btn {
      cursor: pointer;
      background-image: url('../../../assets/icons/icon_blacklist.svg') !important;
      background-size: 63%;
      background-repeat: no-repeat;
      background-position-y: 10px;
      background-position-x: 6px;
      height: 32px;
      width: 32px;
      border: 0px;
      border-radius: 30px;
      margin-left: 2px;
      // padding-bottom: 15px;
      position: relative;
      top: -9px;
      background-color: transparent !important;
    }
    .black-list-btn:hover {
      background-color: #ebf4fd !important;
      // background-position-y: 6px;
      // background-position-x: 6px;
    }
  
    .wy-page-tab {
      border-radius: 5px;
      padding-top: 10px;
      padding-bottom: 3px;
  
      .el-tabs__active-bar {
        // width: 140px !important;
        width: var(--site-tab-item-width);
        // width: var(--site-tab-item-width) !important;
        // background-color: #006FE7;
        background-color: var(--site-tab-item-underline-background-color);
        // height: 3px;
        height: var(--site-tab-item-underline-height);
        // background-color: transparent;
        // padding: 0px 5px;
        padding: var(--site-tab-item-underline-padding);
        // left: -5px;
        left: var(--site-tab-item-underline-left);
      }
      .el-tabs__item {
        // padding: 0px;
        padding: var(--site-tab-item-padding);
        height: 35px;
        line-height: 26px;
        // width: 140px !important;
        width: var(--site-tab-item-width) !important;
        box-sizing: content-box;
        text-align: center;
        color: var(--site-tab-item-color);
        font-weight: 400;
        // font-size: 15px;
        font-size: var(--site-tab-item-font-size);
        // border: 1px solid #cad2da;
        border: var(--site-tab-item-border);
        background-color: var(--site-tab-item-background-color);
        // background-color: #fff;
        // margin-right: 10px;
        margin-right: var(--site-tab-item-margin-right);
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        padding-top: 7px;
      }
      .el-tabs__item.is-top:nth-child(2) {
        padding-left: var(--site-tab-item-padding-nth-child);
      } 
      // padding: 0 20px;
      // height: 40px;
      // -webkit-box-sizing: border-box;
      // box-sizing: border-box;
      // line-height: 40px;
      // display: inline-block;
      // list-style: none;
      // font-size: 14px;
      // font-weight: 500;
      // color: #303133;
      // position: relative;
      .el-tabs__item.is-active {
        // color: #ffffff;
        // color: #005DC2;
        // font-weight: 500;
        background-color: var(--site-tab-active-item-background-color);
        color: var(--site-tab-active-item-color);
        // background-color: #0c2837;
      }
  
      .el-tabs__nav-wrap::after {
        height: 1px;
      }
      #pane-messages,
      #pane-topicRelations,
      #pane-groupedTopics {
        padding: 25px 25px 0px 25px !important;
      }
      #pane-messages,
      #pane-topicRelations,
      #pane-groupedTopics {
        overflow-x: auto;
      }
      #pane-messages {
        margin-right: 20px;
      }
      #pane-conversations {
        overflow-x: auto;
        .wy-contact-reason-transcripts-section {
          min-width: 1378px;
        }
      }
  
      #pane-metrics {
        overflow-x: auto;
        .wy-analytics-contact-reasons-detail-metrics {
          min-width: 1393px;
          height: calc(100vh - 270px) !important;
          overflow-y: auto;
        }
      }
  
      #pane-metricAnalysis {
        overflow-x: auto;
        padding-right: 0px !important;
        padding-bottom: 10px !important;
  
        // OC-1599: Since other tabs are still using old scroll bars for both vertical & horizontal
        // we're commenting this out
        // Horizontal 
        // &::-webkit-scrollbar {
        //   height: 12px !important;
        // }
        // &::-webkit-scrollbar-thumb {
        //   border-radius: 160px !important;
        //   border: 2px solid transparent !important;
        //   border-left: 3px solid transparent !important;
        //   border-right: 3px solid transparent !important;
        //   background-clip: content-box !important;
        //   background-color: #cad2da !important;
        // }
        // &::-webkit-scrollbar-track {
        //   background: #f3f6f8;
        //   border-top: 1px solid #cad2da;
        // }
  
  
        .wy-analytics-contact-reasons-detail-metric-analysis {
          min-width: 1378px;
        }
      }
      #pane-intents {
        overflow-x: auto;
      }
    }
  
    .el-tabs__header {
      margin: 0;
      -moz-user-select: none;
      -khtml-user-select: none;
      -webkit-user-select: none;
    }
  
    .el-tabs.el-tabs--top {
      .el-tabs__content {
        // height: 506px;
        border: 1px solid #cad2da;
        background-color: #ffffff !important;
        // box-shadow: 0px 0px 6px #00000014;
      }
    }
  
    .no-topic-content {
      color: var(--site-font-primary-color);
      background-color: transparent;
      margin-bottom: 3px;
      height: calc(100vh - 495px);
  
      .no-data {
        text-align: center;
        display: block;
        border: none;
        height: 220px;
        margin-top: 120px;
        background-position-x: 50%;
        background-repeat: no-repeat;
        background-size: 300px;
        background-image: url('../../../assets/images/analytics/empty_saved_transcript.svg');
      }
      .no-data-title {
        width: 100%;
        margin-top: 0px;
        text-align: center;
        font-size: 20px;
        color: var(--site-font-primary-color) !important;
        font-weight: 600;
      }
      .no-data-content-first-row {
        width: 100%;
        text-align: center;
        color: var(--site-font-primary-color) !important;
        padding-top: 16px;
        font-size: 14px;
        font-weight: 500;
      }
      .no-data-content-second-row {
        width: 100%;
        text-align: center;
        color: var(--site-font-primary-color) !important;
        font-size: 14px;
        font-weight: 500;
      }
    }
  
    .el-message--warning {
      background-color: #fdf6ec;
      border-color: #faecd8;
      font-weight: 500;
  
      .btn-undo {
        border-radius: 5px;
        padding: 5px;
        border: 1px;
        background-color: #e2ecf7;
        font-weight: 600;
        color: #214586;
        color: #005eb8;
      }
      .btn-undo:hover {
        background-color: #e2ecf7;
      }
    }
    .el-message {
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      border-width: 1px;
      border-style: solid;
      border-color: #fff;
      position: fixed;
      left: 50%;
      top: 90px;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
      background-color: #395167;
      -webkit-transition: opacity 0.3s, top 0.4s, -webkit-transform 0.4s;
      transition: opacity 0.3s, top 0.4s, -webkit-transform 0.4s;
      transition: opacity 0.3s, transform 0.4s, top 0.4s;
      transition: opacity 0.3s, transform 0.4s, top 0.4s, -webkit-transform 0.4s;
      padding: 15px 15px 15px 20px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      // background: #FCFCFC 0% 0% no-repeat padding-box;
      box-shadow: 0px 3px 6px #00000029;
      border: 1px solid #015cb9;
      border-radius: 15px;
      width: fit-content !important;
      min-width: unset;
    }
    .el-message .el-icon-warning {
      color: var(--site-font-primary-color) !important;
    }
    .el-message__icon {
      margin-right: 10px;
    }
    .el-icon-warning:before {
      content: '\E7A3';
    }
    .el-message--warning .el-message__content {
      color: #fff !important;
      padding-right: 30px;
    }
    .undo-merge-success-message .el-message__content {
      padding-right: 0px;
    }
    .el-message.undo-merge-message p {
      padding-right: 30px !important;
    }
    .el-message p {
      padding-right: 4px !important;
    }
    .el-message__content {
      padding: 0;
      font-size: 14px;
      line-height: 1;
    }
  
    .el-loading-mask {
      height: unset !important;
      opacity: unset;
      background-color: unset;
      .el-loading-spinner {
        top: 35%;
        background: var(--site-loading-icon);
        background-repeat: no-repeat;
        background-size: 25px;
        background-position: center;
      }
      .el-loading-spinner .circular {
        display: unset !important;
      }
    }
  }
  </style>
  